export const faqGroups = [
  {
    id: 'about',
    name: '关于看料避雷社',
    items: [
      {
        q: '看料避雷社是做什么的？',
        a: '我们是一个面向普通消费者的避雷内容站，把网购、美妆、数码、食饮、旅宿、教育、理财、家装等场景中反复出现的坑点，整理成「风险等级 + 常见套路 + 避雷清单」三段式内容，帮你在下单和签字之前先看清一遍。',
      },
      {
        q: '这些内容是谁整理的？',
        a: '由编辑团队根据公开的消费争议规律、平台常见规则和用户反馈归纳整理，侧重可执行的检查项，而不是单一案例的吐槽。内容会定期复核和更新。',
      },
      {
        q: '使用这个网站需要付费吗？',
        a: '不需要。所有避雷清单和常见问题都可以免费阅读，订阅更新也是自愿的，随时可以取消。',
      },
    ],
  },
  {
    id: 'usage',
    name: '内容与使用',
    items: [
      {
        q: '每份清单里的「风险等级」是怎么划分的？',
        a: '高风险指可能造成明显资金损失、且事后维权较困难的情况；中风险通常还可以协商解决，但容易吃亏；低风险以体验受损为主，只要提前注意就能避开。等级用于帮你决定先看哪一份。',
      },
      {
        q: '清单里的「避雷清单」和「危险信号」有什么区别？',
        a: '危险信号是你在下单前可以观察到的迹象，用来判断要不要继续；避雷清单是已经决定要买时，逐条执行的检查动作。一个负责判断，一个负责落地。',
      },
      {
        q: '我可以把清单分享给朋友吗？',
        a: '当然可以。我们鼓励你把有用的清单转发给准备下单的家人和朋友，分享时请保留原文链接即可。',
      },
      {
        q: '内容会长期更新的吗？',
        a: '会。平台规则、促销方式和常见套路都在变化，我们会根据新的争议类型补充和修订清单。订阅后可以收到重要更新的提醒。',
      },
    ],
  },
  {
    id: 'feedback',
    name: '内容原则与反馈',
    items: [
      {
        q: '清单里会点名具体的商家吗？',
        a: '通常不会。我们的目标是帮你识别「套路」，而不是针对某个具体品牌。绝大多数坑点会跨商家重复出现，讲清模式比点名更有长期价值。',
      },
      {
        q: '我发现内容有遗漏或者不准确怎么办？',
        a: '欢迎通过页脚的邮箱反馈。请尽量说明具体场景和你遇到的情况，编辑会核实后更新清单。有依据的补充我们都会认真看。',
      },
      {
        q: '遇到实际纠纷，网站能帮我维权吗？',
        a: '我们提供的是判断与预防方法，不直接介入个案处理。发生纠纷时，建议优先通过平台客服、交易凭证和正规投诉渠道解决，清单里的取证建议可以帮助你把材料准备得更完整。',
      },
      {
        q: '为什么有些清单看起来像常识？',
        a: '多数坑点的原理确实不复杂，难点在于下单那一刻是否想得起来。把常识变成一份可以照着做的清单，正是它存在的意义。',
      },
    ],
  },
];